module.exports = __webpack_public_path__ + "static/media/mail.e0a158c3.svg";